import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext, usePageContentContext } from '@synergy/microfrontend_core';

// Define a component called PublicRoute which receives a prop called redirectPath with a default value of '/home'
export const PublicRoute = ({ redirectPath = '/home' }) => {
    // Use the useAuthContext() hook to get the user from the authentication context
    const { user, zones } = useAuthContext();
    const { handlePagePathChange } = usePageContentContext();

    // If there is a user, log the redirection path and navigate to the specified route
    if (user) {
        const pathToRedirect = zones && zones.length > 0 ? '/' + zones[0] : redirectPath;
        handlePagePathChange(pathToRedirect);
        return <Navigate to={pathToRedirect} replace />;
    }

    // If there's no token, render the Outlet component which renders nested routes
    return <Outlet />
};